import React from 'react';
import styles from './ModalForm.module.css';
import { useTranslation } from 'react-i18next';

const Form = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t('place.check.title')}
      </div>

      <div className={styles.description}>
        {t('place.check.description')}
      </div>
    </div>
  )
}

export default Form;
